import { observer } from 'mobx-react-lite'
import { StepsCommonLayout } from 'pages/settings/ui/StepsCommonLayout/StepsCommonLayout'
import { useTollFreeStepsContext } from 'pages/settings/pages/compliance/pages/tollFree/context/tollFreeStepsContext'

export const TollFreeAddNumberLayout = observer(() => {
  const { closeSetting } = useTollFreeStepsContext()

  return (
    <StepsCommonLayout
      progressTitle={'Numbers'}
      totalSteps={1}
      title='Toll-free verification'
      settingsStep={1}
      closeSetting={closeSetting}
      decreaseStep={() => {}}
    />
  )
})
